import React from 'react';
import { CardProps } from '../types';
import styles from './Card.module.scss';

export const Card: React.FC<CardProps> = ({
  children,
  onClick,
  hoverable = false,
  className = '',
  ...props
}) => {
  const cardClasses = [
    styles.card,
    (hoverable || onClick) ? styles.hoverable : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div
      className={cardClasses}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};
